import * as types from 'generated/graphql';

import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';


export const ClientReport: ITypeSpecificPolicy<types.ClientReport> = {
  fields: {
    approvedAt: dateTimeFieldPolicy(),
    createdAt: dateTimeFieldPolicy(),
    startDate: dateTimeFieldPolicy(),
    endDate: dateTimeFieldPolicy(),
    updatedAt: dateTimeFieldPolicy()
  }
};
